export default "__VITE_ASSET__I$Csyhp7__"